import React from "react";
import "./FieldError.css";

/**
 * TIER 1: Field error.
 *
 * Renders red helper text directly under a form input. The most common
 * pattern: the field's `aria-invalid` and `aria-describedby` should point to
 * this element so screen readers announce the error.
 *
 *   <input
 *     value={email}
 *     aria-invalid={!!emailError}
 *     aria-describedby={emailError ? "email-err" : undefined}
 *   />
 *   <FieldError id="email-err" message={emailError} />
 *
 * Renders nothing when message is falsy, so you can leave it in JSX
 * unconditionally.
 */
const FieldError = ({ id, message }) => {
  if (!message) return null;
  return (
    <div id={id} className="field-error" role="alert">
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span>{message}</span>
    </div>
  );
};

export default React.memo(FieldError);
